import { useContext } from 'react';
import HubContext from '../context/HubContext';

const useHub = () => {
  return useContext(HubContext);
};

export default useHub;
